/**
 * Split a FormData key into segments based on brackets.
 *
 * @param key - The FormData key to split
 * @returns Array of segments
 *
 * @example
 * splitKeyIntoSegments('attendees[0][_customField]') // ['attendees', '0', '_customField']
 * splitKeyIntoSegments('firstName') // ['firstName']
 * splitKeyIntoSegments('location[country]') // ['location', 'country']
 * splitKeyIntoSegments('items[]') // ['items', '']
 * splitKeyIntoSegments('data[0][]') // ['data', '0', '']
 */
export const splitKeyIntoSegments = (key: string): Array<string> =>
  key.split(/[\[]/).map((e) => e.replace(/]$/, ''));

/**
 * Join an array of segments into a FormData key.
 *
 * @param segments - The array of segments to join
 * @returns The joined key
 *
 * @example
 * joinSegmentsIntoKey(['attendees', '0', '_customField']) // 'attendees[0][_customField]'
 */
export const joinSegmentsIntoKey = (segments: Array<string>): string => {
  if (segments.length === 0) {
    return '';
  }
  if (segments.length === 1) {
    return segments[0];
  }

  return [segments[0], ...segments.slice(1).map((s) => `[${s}]`)].join('');
};
